import { cn } from '@/lib/utils';

export function StatusDot({
  status,
  className,
}: {
  status: 'up' | 'down' | 'unknown' | string;
  className?: string;
}) {
  const color =
    status === 'up'
      ? 'bg-green-500'
      : status === 'down'
        ? 'bg-red-500'
        : status === 'maintenance'
          ? 'bg-blue-500'
          : 'bg-zinc-400';
  const ring =
    status === 'up'
      ? 'ring-green-500/30'
      : status === 'down'
        ? 'ring-red-500/30'
        : status === 'maintenance'
          ? 'ring-blue-500/30'
          : 'ring-zinc-400/30';
  return (
    <span
      aria-label={status}
      className={cn(
        'inline-block h-2.5 w-2.5 rounded-full ring-4',
        color,
        ring,
        className
      )}
    />
  );
}
